import axios from "axios";
import { Itinerary } from "../interfaces/itinerary.interface";


class SeriesApi {

  getItineraries(searchParamsObj): Promise<Itinerary[]> {
    const searchParamsQuery = new URLSearchParams(searchParamsObj).toString()
    const apiUrl = `/api/v1/series?${searchParamsQuery}&type=series`;

    return axios.get(apiUrl)
    .then(response => {
      const itineraries:Itinerary[] = response.data.itineraries.map(itineraryData => this.mapItinerary(itineraryData));
      return Promise.resolve(itineraries);
    });
  }


  getItinerary(id): Promise<Itinerary>{
    const apiUrl = `/api/v1/series/${id}`;

    return axios.get(apiUrl)
    .then(response => {
      const itinerary = this.mapItinerary(response.data);
      return Promise.resolve(itinerary);
    });
  }


  private mapItinerary(itineraryData):Itinerary {
    const itinerary:Itinerary = {
      id: itineraryData.id,
      description: itineraryData.description,
      caption: itineraryData.caption,
      otherCaption: itineraryData.otherCaption,
      code: itineraryData.code,
      category: itineraryData.category,
      country: itineraryData.country,
      price: itineraryData.price,
      images: itineraryData.images,
      coverImage: itineraryData.images[0],
      priceCurrency: itineraryData.price_currency,
      departureDate: itineraryData.departure_date,
      guranteedDepartureDates: itineraryData.guranteed_departure_dates,
      almostGuaranteedDepartureDates: itineraryData.almost_guaranteed_departure_dates,
      departureLocations: itineraryData.departure_locations,
      totalItineraries: itineraryData.total_itineraries,
      fileUrl: itineraryData.file_url,

      autoCancel: itineraryData.auto_cancel,
      ccRate: itineraryData.cc_rate,
      includings: itineraryData.includings,
      maxBookingSeats: itineraryData.max_booking_seats,
      remark: itineraryData.remark,
      tourType: itineraryData.tour_type,
      tours: itineraryData.tours,
    }

    return itinerary;
  }

}

export default SeriesApi;